import axios from "axios";
import React, {useState, useEffect} from "react";
import backgroundImage from "../../../assets/login-bg-image.png";
import logo from "../../../assets/logo.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Form, Input, Button, Spin } from "antd";
import { validatePassword } from "../../../utils/validator";
import Notification from "../../../components/Notification/Notification";
import { useStateGlobalContext } from "../../../contexts/GlobalContext";

const ForgotPasswordConfirm = () => {
  const [loading, setLoading] = useState(false);
  const { username, token } = useParams();
  const navigate = useNavigate();
  const { appLogoData, getAppLogo } = useStateGlobalContext();

  useEffect(() => {
    getAppLogo();
  }, []);

  const onFinish = (values) => {
    setLoading(true);
    const result = axios
      .post(`${process.env.REACT_APP_API_URL}/user/reset-password/confirm/${username}/${token}/`, values)
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setLoading(false);
          const token = res.data.access;
          localStorage.setItem("token", token);
          Notification.success("Password reset successful");
          navigate("/", { replace: true });
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          Notification.error(err.response.data.detail);
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };


  return (
    <div className="flex flex-col lg:flex-row min-h-screen">
      {/* Left Side - Background Image - Hidden on Mobile */}
      <div
        className="hidden lg:block lg:w-1/2 relative"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute top-6 left-6">
          <img src={appLogoData?.icon || logo} alt="Logo" className="w-[200px]" />
        </div>
      </div>

      {/* Right Side */}
      <div className="w-full lg:w-1/2 flex flex-col items-center justify-center p-4 sm:p-6">
        {/* Logo visible only on mobile */}
        <div className="lg:hidden mb-8 mt-4">
          <img src={appLogoData?.icon || logo} alt="Logo" className="w-[180px] sm:w-[220px]" />
        </div>
        
        <Form
          layout="vertical"
          className="w-full max-w-md"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <h1 className="text-2xl sm:text-3xl mb-3 font-bold text-[#3484F0]">Reset Password</h1>
          <p className="text-sm text-gray-600 mb-4">
            Create a new secure password for your account
          </p>
          
          <Form.Item
            label="New Password"
            name="new_password"
            rules={[
              { required: true, message: "Please input your password!" },
              { validator: validatePassword },
            ]}
          >
            <Input.Password placeholder="Enter new password" size="large" />
          </Form.Item>
          <Form.Item
            name="confirm_password"
            label="Confirm Password"
            hasFeedback
            dependencies={["new_password"]}
            rules={[
              { required: true, message: "Please confirm your password!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject("Passwords do not match!");
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm Password" size="large" />
          </Form.Item>
          <Button
            size="large"
            className="bg-[#3484F0] text-[#fff] w-full mb-4"
            type="primary"
            htmlType="submit"
            disabled={loading}
          >
            {loading ? <Spin /> : "Reset Password"}
          </Button>
          <div className="text-center">
            <p className="text-sm">
              Remember your password?{" "}
              <Link to="/" className="text-[#3484F0]">
                Log in
              </Link>
            </p>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPasswordConfirm;
